import { render, staticRenderFns } from "./click2moneyList.vue?vue&type=template&id=d5a745e2&"
import script from "./click2moneyList.vue?vue&type=script&lang=js&"
export * from "./click2moneyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports